import { FunnelIcon } from '@heroicons/react/24/outline';
import { EllipsisMenu, EllipsisMenuItemType } from '@platform/ui-library';
import {
  FormFieldClassName,
  Switch,
  SwitchProps
} from '@app/form_components';
import style from './MergeDialogControls.module.scss';

function buildHiddenItemsMenuItems(
  hiddenNames: Set<string>,
  onRemoveHiddenName: (name: string) => void,
  onClearHiddenNames: () => void
): EllipsisMenuItemType[] {
  if (hiddenNames.size === 0) {
    return [
      {
        // EllipsisMenu requires an action per row; this row is informational only.
        action: () => {},
        label:
          'No hidden items. Click the eye-off icon next to an item to hide it.'
      }
    ];
  }

  return [
    ...[...hiddenNames].sort().map((name) => ({
      action: () => {
        onRemoveHiddenName(name);
      },
      label: name
    })),
    {
      action: onClearHiddenNames,
      label: 'Show all'
    }
  ];
}

type MergeDialogControlsProps = {
  hidePositionChanges: boolean;
  hiddenNames: Set<string>;
  onClearHiddenNames: () => void;
  onRemoveHiddenName: (name: string) => void;
  onTogglePositionChanges: SwitchProps['onChange'];
};

export function MergeDialogControls({
  hidePositionChanges,
  hiddenNames,
  onClearHiddenNames,
  onRemoveHiddenName,
  onTogglePositionChanges
}: MergeDialogControlsProps) {
  const hiddenItemsMenuItems = buildHiddenItemsMenuItems(
    hiddenNames,
    onRemoveHiddenName,
    onClearHiddenNames
  );

  return (
    <div className={style.controls}>
      <Switch
        fieldConfig={{ className: FormFieldClassName.labelLeft }}
        label="Hide positions"
        name="hide-positions"
        onChange={onTogglePositionChanges}
        tooltip="Hide position-only changes"
        value={hidePositionChanges}
      />
      <EllipsisMenu
        icon={FunnelIcon}
        iconPosition="before"
        items={hiddenItemsMenuItems}
        text={(hiddenNames.size < 1) ? 'Hidden items' : (
          `Hidden items (${hiddenNames.size})`
        )}
        theme="outline"
      />
    </div>
  );
}
